var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- ko let: { $model: $parent } --> <ul class="nfd-list"data-bind="foreach: items"> <li class="nfd-list-item-relative nfd-list-item-hovered"data-bind="css: {\'nfd-list-item-hovered\': $parent.isItemHovered}"> <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko --> </li> </ul> <span class="nfd-text nfd-text-gold pointer new-blue-styles"data-bind="\n	text: text,\n	visible: isTextVisible,\n	click: handleClickOnExpander"></span> <!-- /ko -->';
}
return __p;
};
